import React, { ReactElement } from 'react';

type Props = {
    template: string;
    values: Record<string, string | ReactElement<unknown>>;
};

const interpolationRegexp = new RegExp('{{ *([^} ]+) *}}', 'g');

export const Interpolate: React.FC<Props> = ({ template, values }) => (
    <>
        {/*
            For the template "Hello, {{name}}!", this `.split` will return ["Hello, ", "name", "!"]
            This is because our RegExp contains a capture group `()` and split adds the content of the capture group to returned array

            If two {{}} groups are next to each other, split will add a empty "" between them:
            "Hello, {{group1}}{{group2}}!".split(interpolationRegexp) -> ["Hello, ", "group1", "", "group2", "!"]

            This means that in the returned array:
            - Every item at an even index is a piece of the string that we need to output
            - Every odd item is the content of one of the {{}} expression that we use as a key to lookup in `values`.
        */}
        {template.split(interpolationRegexp).map((str, i) => {
            if (i % 2 === 0) {
                return str;
            }

            const groupValue = values[str];
            if (typeof groupValue === 'string') {
                return groupValue;
            }

            return (
                <React.Fragment key={`${str}-${i}`}>
                    {groupValue}
                </React.Fragment>
            );
        })}
    </>
);
